module.exports = __webpack_public_path__ + "assets/aba-menu-pic.ca1ef6f4.png";